/**
 * Returns an array with all DOM elements affected by an event.
 * The function serves as a polyfill for
 * [`Event.composedPath()`](https://dom.spec.whatwg.org/#dom-event-composedpath).
 *
 * @category Event
 * @param {Event} event The triggered event.
 * @return {Array.<HTMLElement>} The DOM elements affected by the event.
 */
export var getParents = function getParents(node, memo) {
  memo = memo || [];
  var parentNode = node.parentNode;

  if (!parentNode) {
    return memo;
  } else {
    return getParents(parentNode, memo.concat([parentNode]));
  }
};
/**
 * @param event
 * @returns {Window[]|any|*[]}
 */

export var eventPath = function eventPath(event) {
  var path = event.composedPath && event.composedPath() || event.path;
  var target = event.target;

  if (path != null) {
    path = path.indexOf(window) < 0 ? path.concat([window]) : path;
    return path;
  }

  if (target === window) {
    return [window];
  }

  return [target].concat(getParents(target)).concat([window]);
};
export default eventPath;